import { Link } from 'gatsby'
import React from 'react'

const LinkRoute = (props: any) => {
  return <Link activeClassName="active-link" to={props.href} {...props} />
}

export default LinkRoute
